/**
 * Created by yoavp on 12/6/2015.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var BaseModel = require("models/BaseModel");
    var ApiResources = require("assets/data/apiResources.json");

    var UsersListExportModel = {};
    LE.module("LEContent", function (LEContent, LE, Backbone, Marionette, $, _) {

        UsersListExportModel = BaseModel.extend({
            resource: ApiResources.AccountConfigExport.UsersListExport,

            initialize: function (options) {
                options = options || {};
                var isUsersWithProfiles = LE.sessionManager.hasProfilesFeature();
                var fileName = options.fileName;
                this.resource= _.clone(isUsersWithProfiles ? ApiResources.AccountConfigExport.UsersListExportWithProfiles : ApiResources.AccountConfigExport.UsersListExport);
                this.resource.url = this.resource.url.replace("{fileName}", fileName);
            },
            name: "UsersListExportModel"
        });
    });
    return UsersListExportModel;
});
